import {
  FormDataPost,
  Get,
  getAPIUrl,
  Post,
} from "../../ApiServices/apiMethod";

export const HomeEndPoint = {
  getRoomDetails: "/number/room?game_slug=",
  placebet: "/number/betting",
  getBetList: "/number/my-games",
};

export const getRoomDetails = (param = "") => {
  const url = getAPIUrl(HomeEndPoint.getRoomDetails, param);
  return Get(url);
};

export const placebet = (data, param = "") => {
  const url = getAPIUrl(HomeEndPoint.placebet, param);
  return Post(url, data);
};

export const getBetList = (param = "") => {
  const url = getAPIUrl(HomeEndPoint.getBetList, param);
  return Get(url);
};
